<template>
  <div class="container_box">
    <vHeader v-if="system !== 'distributor'" :showNav="false"></vHeader>
    <headTop></headTop>
    <div class="content_box" v-if="guidanceContent">
      <!--预览pdf文件-->
      <div class="pdf_boxs" v-if="guidanceContent.contentType === 0">
        <iframe :src="guidanceContent.pdfUrl" frameborder="0" :style="iframeStyle"></iframe>
      </div>
      <!--预览在线内容-->
      <template v-if="guidanceContent.contentType === 1">
        <div class="preview_online_content_box">
          <div class="copy_box" @click="copyBtn">{{ $t('key1000003') }}</div>
          <div class="online_content_box" v-viewer="viewerOptions" ref="scrollContainer" v-html="guidanceContent.content"></div>
        </div>
        <!--右侧的锚点导航-->
        <anchorNavigation ref="anchorNav" setTop="74px" setRight="210px" :headerHeight="55"></anchorNavigation>
      </template>
    </div>
    <!--返回顶部-->
    <AppBackTop :bottom="60"></AppBackTop>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import vHeader from "@/components/layout/header.vue";
import headTop from '@/components/layout/shopping/common/headTop';
import anchorNavigation from "@/components/common/anchorNavigation.vue";
import {commonCopyContent, setLinkPath} from "@/utils/common";
import AppBackTop from "@/components/common/AppBackTop.vue";

export default {
  name: "viewGuideContent",
  mixins: [Mixin],
  data() {
    return {
      guidanceContent: null,
      iframeStyle: {
        width: '100%',
        minHeight: 'calc(100vh - 57px)',
        border: 'none',
      },
      system: null
    };
  },
  created() {
    let system = localStorage.getItem('system');
    this.system = system;
    this.$webSocket.initWebSocket();
    this.getSystemOperationGuidelinesData();
  },

  methods: {
    // 获取对应系统的操作指引数据
    getSystemOperationGuidelinesData() {
      let v = this;
      v.guidanceContent = null;
      let docsId = v.$route.query.docsId;
      v.axios.get(api.get_helpCenterDocs_noPermission + docsId, null, {loading: true}).then((res) => {
        if (res.data.code === 0) {
          let data = res.data.datas;
          let obj = data.docsInternationalQueryResultList.find(dItem => dItem.language === v.languagesVal) || {};
          data = {
            ...data,
            ...obj,
          };
          // pdf文件
          if (data.contentType === 0) {
            try {
              let jsData = JSON.parse(data.content);
              data.pdfUrl = setLinkPath(jsData.url);
            } catch (e) {
              data.pdfUrl = setLinkPath(data.content);
            }
          }
          // 在线内容
          if (data.contentType === 1) {
            data.content = v.setImageStyle(data.content);
          }
          v.guidanceContent = data;
          v.scrollTopFun();
          if (data.contentType === 1) {
            v.$nextTick(() => {
              setTimeout(() => {
                const content = v.$el.querySelector('.online_content_box');
                let dom = v.$refs['scrollContainer'];
                v.$refs['anchorNav'].getAnchorsFromContent(dom, content);
              }, 1000);
            });
          }



          /*if (data) {

            } else {
              v.$Message.warning('内容已被停用或删除！');
              return false;
            }
          } else {
            v.$Message.warning('内容已被停用或删除！');
            return false;
          }*/
        }
      });
    },
    // 动态设置渲染图片的大小的样式
    setImageStyle(html) {
      // 创建一个临时div用于解析HTML内容
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      // 获取解析后的img标签集合
      const images = tempDiv.getElementsByTagName('img');
      Array.from(images).forEach(image => {
        // 设置图片样式
        image.style.maxWidth = '928px';
        image.style.height = 'auto';
      });
      // 返回更新后的HTML内容
      return tempDiv.innerHTML;
    },
    // 复制
    copyBtn() {
      let href = window.location.href;
      let content = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000000')}${this.guidanceContent.title}\n` + `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000001')}${href}`;
      if (content) {
        commonCopyContent(content, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000002'));
      }
    }
  },
  components: {
    anchorNavigation,
    vHeader,
    headTop,
    AppBackTop
  }
};
</script>

<style lang="less">
.container_box {
  width: 100%;
  min-height: 100vh;
  overflow-y: auto;
  background-color: #F1F1F1;

  .content_box {
    padding-top: 50px;

    .preview_online_content_box {
      margin: 24px auto;
      width: 928px;
      background-color: #fff;
      position: relative;

      .copy_box {
        position: absolute;
        top: 15px;
        right: 20px;
        z-index: 10;
        cursor: pointer;
      }
    }

    .online_content_box {
      width: 100%;
      padding: 20px;

      img {
        max-width: 888px !important;
      }

      p, p > span {
        text-wrap: inherit !important;
        word-wrap: break-word !important;
        word-break: break-all !important;
      }
    }
  }
}
</style>
